<script lang="ts">
	import Play from '$lib/icons/play.svelte';
	import FullscreenVideo from '$lib/fullscreenVideo.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import Blok from '$lib/storyblok/blok.svelte';

	interface Props {
		content: ISbStoryData<{
			playback_id: string;
			body: ISbStoryData[];
			label: string;
		}>['content'];
	}

	let { content }: Props = $props();

	let showVideo = $state(false);
</script>

<div use:editable={content} class="relative">
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<div role="button" tabindex="0" onclick={() => (showVideo = true)} class="cursor-pointer">
		{#each content.body || [] as block}
			<Blok content={block} />
		{/each}
		<div class="absolute inset-x-0 bottom-[28px] flex justify-center">
			<div
				class="flex items-center justify-center gap-x-2 rounded-full bg-black/[0.24] p-2 pr-4 backdrop-blur-md transition-colors hover:bg-black/[0.48]"
			>
				<div class="rounded-full p-2 backdrop-blur-lg">
					<Play class="h-4 w-4 text-white" />
				</div>
				<p class="text-[16px]/[150%] text-white">{content.label}</p>
			</div>
		</div>
	</div>
</div>

{#if showVideo}
	<FullscreenVideo
		backgroundWithOpacity
		buttonPos="top-right"
		playbackId={content.playback_id}
		onclose={() => (showVideo = false)}
	/>
{/if}
